// app/ClientHomeClient.tsx
"use client";

import dynamic from "next/dynamic";

// Use dynamic to keep bundle split, but in a client boundary.
const ClientHome = dynamic(() => import("./ClientHome"), {
  ssr: false,
  loading: () => null,
});

export default function ClientHomeClient() {
  return <ClientHome />;
}
